import { useQuery } from "@tanstack/react-query";
import { readData } from "../OrderService";

/**
 * Unique Query Key for Order Details / Read API
 */
export const ORDER_DETAILS_QUERY_KEY = (orderId) => ["orderDetails", String(orderId)];

/**
 * TanStack React Query Hook for Order Read API
 * Fetches order details, formats KYC/status, populates Redux store, and caches with unique query key.
 */
export const useOrderDetails = (orderId, options = {}) => {
  return useQuery({
    queryKey: ORDER_DETAILS_QUERY_KEY(orderId),
    queryFn: async () => {
      if (!orderId) return null;
      return await readData(orderId, "ODR");
    },
    enabled: !!orderId,
    staleTime: 0, // Always fetch fresh order data or on invalidation
    ...options,
  });
};

export default useOrderDetails;
